import { render, staticRenderFns } from "./requirementItem.vue?vue&type=template&id=bdae17cc&functional=true&"
import script from "./requirementItem.vue?vue&type=script&lang=ts&"
export * from "./requirementItem.vue?vue&type=script&lang=ts&"
import style0 from "./requirementItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports